import { IColumn } from '@xcritical/grid';

import { renderTruncateStringColumn } from '@crm-framework/grid';

import { renderStatusColumn } from './columnRenderers';

export const GROUP_IMPORT_CONFIRM_MODAL = 'GROUP_IMPORT_CONFIRM_MODAL';
export const GROUP_IMPORT_MODAL = 'GROUP_IMPORT_MODAL';
export const GROUP_IMPORT_GRID = 'GROUP_IMPORT_GRID';

export const GROUP_OPERATION_REGISTRY = 'GROUP_OPERATION_REGISTRY';

export const GROUP_IMPORT_COLUMNS: IColumn[] = [
  {
    headerName: 'Client Id',
    field: 'clientId',
    width: 100,
    visible: true,
  },
  {
    headerName: 'Status',
    field: 'successfull',
    width: 50,
    visible: true,
    render: renderStatusColumn,
  },
  {
    headerName: 'Comment',
    field: 'comment',
    width: 180,
    visible: true,
    render: renderTruncateStringColumn,
  },
];
